import { combineReducers } from "redux";
import { productsReducer } from "./products_reducer";
import { categoriesReducer } from "./categories_reducer";
import { loadingReducer } from "./loading_reducer";
import { portalReducer } from "./portal_reducer";
import { pathParamsReducer } from "./path_params_reducer";
import { menuCategoriesReducer } from "./menu_categories_reducer";
import { currProductReducer } from "./curr_product_reducer";

export const rootReducer = combineReducers({
  products: productsReducer,
  categories: categoriesReducer,
  loading: loadingReducer,
  portal: portalReducer,
  pathParams: pathParamsReducer,
  menuCategories: menuCategoriesReducer,
  currProduct: currProductReducer,
});
